module.exports = __webpack_public_path__ + "img/phone.4fe86b1e.svg";